import * as React from 'react';
import { Spin } from 'antd';
import { default as styled } from 'styled-components';

export const NiSpin = styled(Spin)`
  .ant-spin-blur {
    overflow: visible;
    opacity: 1;
  }
`;
